import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "This sound example demonstrates the advantage of binaural hearing for selective listening. For both mono and binaural recording try to shift your attention between the two neraby speakers.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 2,
      rowsSize: [5, 1],
      colSpan: { "0:0": 2 },
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/02/11/principle/cocktail-party.png`,
                  styles: {
                    maxHeight: "364px",
                    maxWidth: "626px",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioButton",
                options: {
                  text: "Mono",
                  icon: "cis-volume-high",
                  shape: "round",
                  theme: "secondary",
                  size: "large",
                  url: `${config.ASSETS_URL}/02/11/principle/cocktail-party-mono.wav`,
                },
              },
              styles: {
                justifyContent: "flex-end",
                padding: "5%",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioButton",
                options: {
                  text: "Binaural",
                  icon: "cis-volume-high",
                  shape: "round",
                  theme: "secondary",
                  size: "large",
                  url: `${config.ASSETS_URL}/02/11/principle/cocktail-party-binaural.wav`,
                },
              },
              styles: {
                justifyContent: "flex-start",
                padding: "5%",
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
